<template>
	<SignUpPageBase :content="this">
		<h4 class="font_lg font_bold margin_title_bottom">{{ $t("signUp.representativeUser.title") }}</h4>
		<form class="flex flex_center flex_column w_100">
			<div class="margin_vertical flex flex_column">
				<p>{{ $t("signUp.representativeUser.isMasterUserRepresentative1") }}</p>
				<p>{{ $t("signUp.representativeUser.isMasterUserRepresentative2") }}</p>
				<md-radio
					:class="{ 'md-error': errors.first('isMasterUserRepresentative') }"
					v-model="form.isMasterUserRepresentative"
					:value="true"
					v-validate="modelValidations.isMasterUserRepresentative"
					data-vv-name="isMasterUserRepresentative"
					required
				>
					{{ $t("signUp.representativeUser.isMasterUserRepresentative.choice.yes") }}
				</md-radio>
				<md-radio
					style="margin-top: 0"
					:class="{ 'md-error': errors.first('isMasterUserRepresentative') }"
					v-model="form.isMasterUserRepresentative"
					:value="false"
					v-validate="modelValidations.isMasterUserRepresentative"
					data-vv-name="isMasterUserRepresentative"
					required
				>
					{{ $t("signUp.representativeUser.isMasterUserRepresentative.choice.no") }}
				</md-radio>
			</div>
			<div class="margin_top flex flex_column">
				<span>{{ $t("signUp.representativeUser.hasSolePowerOfRepresentation") }}</span>
				<md-radio
					:class="{ 'md-error': errors.first('hasSolePowerOfRepresentation') }"
					v-model="form.hasSolePowerOfRepresentation"
					:value="true"
					v-validate="modelValidations.hasSolePowerOfRepresentation"
					data-vv-name="hasSolePowerOfRepresentation"
					required
				>
					{{ $t("signUp.representativeUser.hasSolePowerOfRepresentation.choice.yes") }}
				</md-radio>
				<md-radio
					style="margin-top: 0"
					:class="{ 'md-error': errors.first('hasSolePowerOfRepresentation') }"
					v-model="form.hasSolePowerOfRepresentation"
					:value="false"
					v-validate="modelValidations.hasSolePowerOfRepresentation"
					data-vv-name="hasSolePowerOfRepresentation"
					required
				>
					{{ $t("signUp.representativeUser.hasSolePowerOfRepresentation.choice.no") }}
				</md-radio>
			</div>
		</form>
	</SignUpPageBase>
</template>

<script>
import SignUpPageBase from "@/views/register/SignUpPageBase";
import {mapGetters} from "vuex";

export default {
	components: {
		SignUpPageBase
	},
	data() {
		return {
			form: {
				isMasterUserRepresentative: null,
				hasSolePowerOfRepresentation: null,
			},
			modelValidations: {
				isMasterUserRepresentative: {
					required: true,
				},
				hasSolePowerOfRepresentation: {
					required: true
				},
			}
		};
	},
	created() {
		this.$mergeOnlyExistingProps(this.form, this.signUpData, true);
	},
	computed: {
		...mapGetters({
			signUpData: "local/signUpData"
		})
	},
};
</script>